// @flow

export function mapDict<T>(dict: { [any]: T }, mapper: T => any): Array<any> {
  const keys = Object.keys(dict);
  return keys.map(key => {
    return mapper(dict[key]);
  });
}
